export { default } from './LocationMobile';
